export const AKBANK_ELIGIBLE_ESTATE_TYPES = ["Konut"];
